document.addEventListener('DOMContentLoaded', () => {
    // Mapeamento de cores personalizadas (se necessário)
    const colorMapping = {
        'rosa': 'pink',
        'roxo': 'purple',
        'bronze': '#cd7f32', // Bronze
        'azul': '#005BD3',
        'preto': 'black',
        'bege': '#EAD8AB', // Beige
        'vermelho': 'red',
        'verde': 'green',
        'verde-limao': '#D3FF00', // Corrigido com vírgula
        'branco': 'white',
        'amarelo': 'yellow',
        'gray': 'gray',
        'cinza': 'silver',
        'azul-claro': '#A7E0FF', // Light Blue
        'verde-claro': '#B4E1BA', // Light Green
        'aveia': '#FFF9E9',
        'marrom': '#9A5630',
        'nude': '#FFF9E9',
        'verde-oliva': '#507B4F',
        'off-white': '#F5F5F5',
        'azul-marinho': '#282099',
        'mascavo': '#C28675',
         'vinho': '#632186',
         'turmalina': '#5EF4D9',
         'topazio': '#7FD0FD',
         'barbante': '#E3D8CF',
         'camomila': '#F5FFBF',
         'caramelo': '#ECCE92',
         'creme': '#EEE7C8',
         'melancia': '#FF2E2E',
         'toast': '#CA9978',
         'terracota': '#C45824'
        // Adicione mais cores, conforme necessário
    };

    // Função para aplicar as cores com base na classe do elemento
    const applyColorsToElements = () => {
        // Seleciona todos os elementos que possuem classes relacionadas a cores
        const colorElements = document.querySelectorAll('[class*="bg_color_"]');

        if (colorElements.length === 0) {
            console.warn('Nenhum elemento com classe "bg_color_" encontrado.');
        }

        colorElements.forEach(element => {
            if (element.dataset.colorApplied) return; // Evita reaplicação

            // Captura a classe que começa com "bg_color_"
            const className = Array.from(element.classList).find(cls => cls.startsWith('bg_color_'));
            if (className) {
                // Extrai o nome da cor da classe (exemplo: "bg_color_bronze" -> "bronze")
                const colorName = className.replace('bg_color_', '').toLowerCase();

                // Mapeia o nome da cor para um código CSS ou usa o nome diretamente
                const color = colorMapping[colorName] || colorName; // Usa o nome diretamente caso não esteja no mapeamento

                // Aplica a cor ao fundo do elemento
                element.style.setProperty('background-color', color, 'important');

                // Marca como processado
                element.dataset.colorApplied = true;
            } else {
                console.warn('Nenhuma classe "bg_color_*" detectada no elemento:', element);
            }
        });
    };

    // Observa mudanças no DOM para elementos dinâmicos
    const observer = new MutationObserver(() => {
        applyColorsToElements();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Aplica as cores nos elementos já presentes
    applyColorsToElements();
});